const detectOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) return 'Windows Phone';
    if (/android/i.test(userAgent)) return 'Android';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';
    if (/Macintosh/.test(userAgent) && 'ontouchend' in document) return 'iOS';
    if (/Macintosh/.test(userAgent)) return 'Mac OS';
    if (/Windows/.test(userAgent)) return 'Windows';
    if (/Linux/.test(userAgent)) return 'Linux';

    return 'Unknown';
};

const init = () => {
    const os = detectOS();
    document.documentElement.setAttribute('data-os', os);
};

export { detectOS };
export default { init };
